import { useMutation } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { type FormEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "../../api/client.js";
import { AuthLayout, Button, ErrorNotice, Field, Input } from "../../components/form.js";

export function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const forgot = useMutation({ mutationFn: () => api.auth.password.forgot(email) });

  const onSubmit = (event: FormEvent) => {
    event.preventDefault();
    forgot.mutate();
  };

  if (forgot.isSuccess) {
    return (
      <AuthLayout
        title={t("auth.forgot.sentTitle")}
        subtitle={t("auth.forgot.sentSubtitle", { email })}
      >
        <div className="flex flex-col gap-4 text-sm text-ink-2">
          <p>{t("auth.forgot.sentHint")}</p>
          <Link to="/login" className="text-accent underline-offset-2 hover:underline">
            {t("auth.signup.signIn")}
          </Link>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title={t("auth.forgot.title")} subtitle={t("auth.forgot.subtitle")}>
      <form onSubmit={onSubmit} className="flex flex-col gap-4">
        <Field label={t("auth.fields.email")}>
          <Input
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Field>
        <ErrorNotice error={forgot.error} />
        <Button type="submit" disabled={forgot.isPending}>
          {forgot.isPending ? t("common.loading") : t("auth.forgot.submit")}
        </Button>
        <p className="text-center text-sm text-ink-2">
          <Link to="/login" className="text-accent underline-offset-2 hover:underline">
            {t("auth.forgot.back")}
          </Link>
        </p>
      </form>
    </AuthLayout>
  );
}
